import { IBridge } from "@multiweb/reactCore/bridge/api";
import { proxyBridgeInstance } from "./ProxyBridge";

export * from "@multiweb/reactCore/bridge/api";
export const bridge: IBridge = proxyBridgeInstance;
